import HttpServices from "./HttpServices";
import moment from "moment";

export default {

    async editTask(id, title, description) {
        return await HttpServices.patch(`/task/${id}`, {
            title: title,
            description: description
        });
    },

    async createTask(date, title, description, bubble) {
        return await HttpServices.post(`/task`, {
            date: moment(date).format("YYYY-MM-DD"),
            title: title,
            bubble_id: bubble ? bubble.id : undefined
        });
    },

    async deleteTask(id) {
        return await HttpServices.delete(`/task/${id}`, {});
    },

    async completeOrUncompleteTask(id, completed) {
        if (completed) {
            return await HttpServices.post(`/task/${id}/complete`, {
                completion_date: moment().format("YYYY-MM-DD")
            });
        } else {
            return await HttpServices.post(`/task/${id}/uncomplete`);
        }
    },

    async listTasks(date) {
        return await HttpServices.get(`/task/day/${date}`);
    }

}


// WEBPACK FOOTER //
// ./src/services/TaskServices.js